import { defineStorefront } from "@kss/storefront-config"
import { installationStorefront } from "./installations"
import { bwatcher } from "./bwatcher"
import { zilmet } from "./zilmet"

const storefronts = {
  zilmet,
  bwatcher,
  kruuse: defineStorefront({
    id: "kruuse",
    origin: "https://kruuse.cl",
    locale: "es-CL",
    currencyCode: "clp",
    brand: {
      name: "Kruuse Chile",
      shortName: "Kruuse",
      logoPath: "/favicon.ico",
    },
    header: {
      logoDisplay: "wordmark",
      showAccount: true,
      showSearch: false,
      sticky: true,
      desktopCategoryLimit: 4,
    },
    commerce: {
      defaultCountryCode: "cl",
      backendUrlEnv: "NEXT_PUBLIC_MEDUSA_BACKEND_URL",
      publishableKeyEnv: "NEXT_PUBLIC_MEDUSA_PUBLISHABLE_KEY",
      salesChannelIdEnv: "NEXT_PUBLIC_MEDUSA_SALES_CHANNEL_ID",
      taxPresentation: "net-plus-vat",
    },
    search: {
      tenant: "kruuse",
      gatewayUrlEnv: "NEXT_PUBLIC_SEARCH_GATEWAY_URL",
    },
    cache: { namespace: "kruuse" },
    theme: {
      colorBrand: "#a60100",
      colorBrandHover: "#dd3333",
      colorOnBrand: "#ffffff",
      colorAccent: "#004886",
      colorBackground: "#ffffff",
      colorSurface: "#ffffff",
      colorForeground: "#111827",
      colorMuted: "#6b6b6b",
      colorBorder: "#e5e7eb",
      colorFocus: "#004886",
      colorHeaderBackground: "#a60100",
      colorHeaderForeground: "#ffffff",
      colorHeaderBorder: "#c02a29",
      colorHeaderInteractive: "#dd3333",
      colorHeaderBadgeBackground: "#ffffff",
      colorHeaderBadgeForeground: "#a60100",
      fontSans: "Lato, Helvetica Neue, Helvetica, Arial, sans-serif",
      fontHeading: "Lato, Helvetica Neue, Helvetica, Arial, sans-serif",
      headerHeight: "4rem",
      headerLogoMaxWidth: "8.25rem",
      radiusControl: "0.5rem",
      radiusCard: "1rem",
      shadowCard: "0 12px 32px rgb(17 24 39 / 0.08)",
    },
    features: {
      blog: true,
      renting: true,
      quotes: true,
      reviews: true,
      wishlist: false,
      receptionist: true,
    },
  }),
  scheppach: defineStorefront({
    id: "scheppach",
    origin: "https://scheppach.cl",
    locale: "es-CL",
    currencyCode: "clp",
    brand: {
      name: "Scheppach Chile",
      shortName: "Scheppach",
      logoPath: "/favicon.ico",
    },
    header: {
      logoDisplay: "wordmark",
      showAccount: true,
      showSearch: false,
      sticky: true,
      desktopCategoryLimit: 4,
    },
    commerce: {
      defaultCountryCode: "cl",
      backendUrlEnv: "NEXT_PUBLIC_MEDUSA_BACKEND_URL",
      publishableKeyEnv: "NEXT_PUBLIC_MEDUSA_PUBLISHABLE_KEY",
      salesChannelIdEnv: "NEXT_PUBLIC_MEDUSA_SALES_CHANNEL_ID",
      taxPresentation: "gross",
    },
    search: {
      tenant: "scheppach",
      gatewayUrlEnv: "NEXT_PUBLIC_SEARCH_GATEWAY_URL",
    },
    cache: { namespace: "scheppach" },
    theme: {
      colorBrand: "#1e40af",
      colorBrandHover: "#003d82",
      colorOnBrand: "#ffffff",
      colorAccent: "#0f1b5c",
      colorBackground: "#ffffff",
      colorSurface: "#ffffff",
      colorForeground: "#111827",
      colorMuted: "#524f53",
      colorBorder: "#e5e7eb",
      colorFocus: "#1e40af",
      colorHeaderBackground: "#0f1b5c",
      colorHeaderForeground: "#ffffff",
      colorHeaderBorder: "#26346f",
      colorHeaderInteractive: "#1e40af",
      colorHeaderBadgeBackground: "#ffffff",
      colorHeaderBadgeForeground: "#0f1b5c",
      fontSans: "Inter, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif",
      fontHeading: "Helvetica Neue, Helvetica, Arial, sans-serif",
      headerHeight: "3.75rem",
      headerLogoMaxWidth: "9rem",
      radiusControl: "0.5rem",
      radiusCard: "1rem",
      shadowCard: "0 12px 32px rgb(15 27 92 / 0.08)",
    },
    features: {
      blog: true,
      renting: false,
      quotes: false,
      reviews: true,
      wishlist: true,
      receptionist: false,
    },
  }),
} as const

const storefrontId: unknown = process.env.NEXT_PUBLIC_STOREFRONT_ID
if (
  storefrontId !== "kruuse" &&
  storefrontId !== "scheppach" &&
  storefrontId !== "instalaciones" &&
  storefrontId !== "bwatcher" &&
  storefrontId !== "zilmet"
) {
  throw new Error(
    "NEXT_PUBLIC_STOREFRONT_ID must be kruuse, scheppach, instalaciones, bwatcher or zilmet"
  )
}

export const storefront =
  storefrontId === "instalaciones"
    ? installationStorefront()
    : storefronts[storefrontId]
